module.exports = {"610623001":"瓦窑堡街道","610623101":"杨家园子镇","610623102":"玉家湾镇","610623103":"安定镇","610623104":"马家砭镇","610623105":"南沟岔镇","610623106":"涧峪岔镇","610623107":"李家岔镇","610623108":"余家坪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610623.json
// module id = 2628
// module chunks = 0